module.exports = __webpack_public_path__ + "img/ico-arrow-30-white.a30ceb96.svg";